import { MessageActivity, type MessageActivityProps } from "./MessageActivity";
import { CompletedMessageActivity } from "./CompletedMessageActivity";

export function AssistantMessageActivity(props: MessageActivityProps) {
  // A separate component resets disclosure state when an active turn completes.
  return props.message.generationStatus === "completed" ||
    !props.message.generationStatus ? (
    <CompletedMessageActivity {...props} />
  ) : (
    <MessageActivity {...props} />
  );
}
